import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enUS from './locales/en-US';
import esMX from './locales/es-MX';

const resources = {
  'en-US': {
    translation: enUS
  },
  'es-MX': {
    translation: esMX
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('language') || 'es-MX', // default language
  fallbackLng: 'es-MX',
  interpolation: {
    escapeValue: false // react already safes from xss
  }
});

export default i18n;
